import PrevModal from "./modal"

export default PrevModal
